import { useRole } from '../../hooks/useRole'

/**
 * Role switcher dropdown component
 * Only visible to admin users
 * Allows switching between Admin and User roles
 */
export default function RoleSwitcher() {
  const { activeRole, switchRole, isAdmin, ROLE_ADMIN, ROLE_USER } = useRole()

  // Don't render if user is not an admin
  if (!isAdmin) {
    return null
  }

  const handleRoleChange = (event) => {
    const newRole = event.target.value
    switchRole(newRole)
  }

  return (
    <select
      value={activeRole}
      onChange={handleRoleChange}
      className="px-3 py-[4px] font-medium text-[#002231] border-2 border-[#CCCCCC] rounded bg-white cursor-pointer focus:outline-none focus:border-[#002231] transition-colors"
      aria-label="Switch role"
    >
      <option value={ROLE_ADMIN}>Admin</option>
      <option value={ROLE_USER}>User</option>
    </select>
  )
}

